import Vue from 'vue'
import router from '@/router'
import store from '@/store/'
import { ACCESS_TOKEN,USER_INFO, USER_ROLE } from "@/store/mutation-types";
import HomeLayout from './layouts/HomeLayout'
import CmsLayout from './layouts/CmsLayout'
import UserLayout from './layouts/UserLayout'
import BlankLayout from '@/components/layouts/BlankLayout'
import { getAction } from "@/api/manage";

const whiteList = ['/login', '/home', '/cms', '/cert/query'] // no redirect whitelist
//改变地址栏参数
const changeURLStatic = function(name, value) {
  var url = location.href;
  var reg = eval('/([\?|&]'+name+'=)[^&]*/gi');
  value = value.toString().replace(/(^\s*)|(\s*$)/g,"");
  if(!value){
      var url2 = url.replace(reg , '');
  }else{
      if(url.match(reg)){
          var url2 = url.replace(reg , '$1' + value);
      }else{
          var url2 = url + (url.indexOf('?') > -1 ? '&' : '?') + name + '=' +value;
      }
  }
  history.replaceState(null,null, url2);
}

router.beforeEach((to, from, next) => {

  if(to.query.qqtoken){ //智启token登录
    getAction("/thirdLogin/zhiqi/getUserInfo?qqtoken=" + to.query.qqtoken).then(tokenRes=>{
      if(tokenRes.success){
        getAction("/thirdLogin/getLoginUser/" + tokenRes.result).then(res=>{
          if(res.success){
            let token = res.result.token
            let userInfo = res.result.userInfo
            const expire = 7 * 24 * 60 * 60 * 1000
            Vue.ls.set(ACCESS_TOKEN, token, expire)
            store.commit('SET_TOKEN', token)
            Vue.ls.set(USER_INFO, userInfo, expire)
            store.commit('SET_USER_INFO', userInfo)
            store.commit('SET_NAME', { username: userInfo.username, realname: userInfo.realname })
            store.commit('SET_AVATAR', userInfo.avatar)
            changeURLStatic("qqtoken", "")
            window.location.reload()
          }else{
            alert("登录失败")
          }
        })
      }else{
        alert("登录失败,Token无效")
      }
    })
  }

  if (Vue.ls.get(ACCESS_TOKEN)) {
      next()
  } else {
    if (whiteList.indexOf(to.path) == -1) {
      next()
      // next({ path: '/user/login', query: { redirect: to.fullPath } })
    }else{
      next()
    }
  }
})
let tenantConfig = store.getters.tenantInfo
/**
 * 基础路由
 * @type { *[] }
 */
const RouterMap = [
  
  {
    path: '/',
    component: HomeLayout,
    redirect: tenantConfig && tenantConfig.home || '/index',
    hidden: true,
    children: [
      {
        path: '/index2',
        name: 'home2',
        component: () => import(/* webpackChunkName: "aice" */ './views/Home')
      },
      {
        path: '/index',
        name: 'home',
        component: () => import(/* webpackChunkName: "aice" */ './views/Home2')
      },
    ]
  },
  {
    path: '/',
    component: CmsLayout,
    redirect: '/index',
    hidden: true,
    children: [
      {
        path: '/login',
        name: 'login',
        component:() => import(/* webpackChunkName: "aice" */ './views/user/Login')
      },
      {
        path: '/register',
        name: 'register',
        component:() => import(/* webpackChunkName: "aice" */ './views/user/Register')
      },
      {
        path: '/find',
        name: 'find',
        component:()=>import(/* webpackChunkName: "aice" */ './views/user/Find')
      }
    ]
  },
  {
    path: '/examine',
    component:()=>import(/* webpackChunkName: "aice" */ '@/components/exam/Examine')
  },
  {
    path: '/cert',
    component: BlankLayout,
    redirect: '/cert/query',
    hidden: true,
    children: [
      {
        path: '/cert/aidoc',
        name: 'aidocindex',
        component: () => import(/* webpackChunkName: "aice" */ './views/aidoc/AidocIndex')
      },
      {
        path: '/cert/aidoclogin',
        name: 'aidoclogin',
        component: () => import(/* webpackChunkName: "aice" */ './views/aidoc/AidocLogin')
      },
      {
        path: '/cert/aidoclist',
        name: 'aidoclist',
        component: () => import(/* webpackChunkName: "aice" */ './views/aidoc/AidocList')
      },
      {
        path: '/cert/query',
        name: 'certQuery',
        component: () => import(/* webpackChunkName: "aice" */ './views/CertQuery')
      },
      {
        path: '/cert/score',
        name: 'scoreQuery',
        component: () => import(/* webpackChunkName: "aice" */ './views/ScoreQuery')
      },
      // {
      //   path: '/cert/score',
      //   name: 'scoreQuery',
      //   component: () => import(/* webpackChunkName: "aice" */ './views/ScoreQuery')
      // },
      {
        path: '/cert/studentReport',
        name: 'studentReport',
        component: () => import(/* webpackChunkName: "aice" */ './views/StudentCategoryReport')
      },
      {
        path: '/cert/schoolReport',
        name: 'schoolReport',
        component: () => import(/* webpackChunkName: "aice" */ './views/SchoolCategoryReport')
      }
    ]
  },
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/event',
    children: [
      {
        path: 'event',
        name: 'userEvent',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Event')
      },
      {
        path: 'order',
        name: 'userOrder',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Order')
      },
      {
        path: 'info',
        name: 'userInfo',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Info')
      },
      {
        path: 'cert',
        name: 'userCert',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Cert')
      },
      {
        path: 'score',
        name: 'userScore',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Score')
      },
      {
        path: 'setting',
        name: 'userSetting',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Setting')
      },
      {
        path: 'work',
        name: 'userWork',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Work')
      },
      {
        path: 'question',
        name: 'userQuestion',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/Question')
      },
      {
        path: 'myPaper',
        name: 'myPaper',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/MyPaper')
      },
      {
        path: 'myPaperAnswer',
        name: 'myPaperAnswer',
        component: () => import(/* webpackChunkName: "aice" */ './views/user/MyPaperAnswer')
      },
      {
        path: 'userPaper',
        name: 'userPaper',
        component: () => import(/* webpackChunkName: "aice" */ '@/components/exam/UserPaperPreview')
      },
    ]
  },
  {
    path: '/event',
    name: 'event',
    redirect: '/event/cate',
    component: CmsLayout,
    children:[
      {
        path: 'enter',
        name: 'eventEnter',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventEnter')
      },
      {
        path: 'cate',
        name: 'eventCategory',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventCategory')
      },
      {
        path: 'list',
        name: 'eventList',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventList')
      },
      {
        path: 'detail',
        name: 'eventDetail',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventDetail')
      },
      {
        path: 'apply',
        name: 'eventApply',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventApply')
      },
      {
        path: 'desc',
        name: 'eventDesc',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventDesc')
      },
      {
        path: 'trends',
        name: 'eventTrends',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventTrends')
      },
      {
        path: 'old',
        name: 'eventOld',
        component: () => import(/* webpackChunkName: "aice" */ './views/EventOld')
      },
      {
        path: 'workList',
        name: 'workList',
        component: () => import(/* webpackChunkName: "aice" */ './views/WorkList')
      },
      {
        path: 'workDetail',
        name: 'workDetail',
        component: () => import(/* webpackChunkName: "aice" */ './views/WorkDetail')
      },
    ]
  },
  {
    path: '/activity',
    name: 'activity',
    redirect: '/activity/list',
    component: CmsLayout,
    children:[
      {
        path: 'list',
        name: 'activityList',
        component: () => import(/* webpackChunkName: "aice" */ './views/ActivityList')
      },
      {
        path: 'detail',
        name: 'activityDetail',
        component: () => import(/* webpackChunkName: "aice" */ './views/ActivityDetail')
      },
    ]
  },
  {
    path: '/cms',
    name: 'cms',
    redirect: '/cms/list',
    component: CmsLayout,
    children: [
      {
        path: 'list',
        name: 'cmsList',
        component: () => import(/* webpackChunkName: "aice" */ './views/CmsList')
      },
      {
        path: 'preview',
        name: 'cmsPreview',
        component: ()=> import(/* webpackChunkName: "aice" */ './views/CmsPreviewList')
      },
      {
        path: 'detail',
        name: 'cmsDetail',
        component: () => import(/* webpackChunkName: "aice" */ './views/CmsDetail')
      },
      {
        path: 'video',
        name: 'cmsVideo',
        component: () => import(/* webpackChunkName: "aice" */'./views/VideoList')
      },
      {
        path: 'pic',
        name: 'cmsPic',
        component: () => import(/* webpackChunkName: "aice" */'./views/PicList')
      },
      {
        path: 'live',
        name: 'cmsLive',
        component: () => import(/* webpackChunkName: "aice" */'./views/LiveList')
      },
      {
        path: 'people',
        name: 'cmsPeople',
        component: () => import(/* webpackChunkName: "aice" */'./views/PeopleList')
      }
    ]
  },

]
export default RouterMap